export default __webpack_public_path__ + "static/media/logo-tablet.b08436c0.svg";